import PropTypes from 'prop-types';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import { useEffect, useRef, useState } from 'react';
import FJImage from '../../../../common/components/FJImage/FJImage.jsx';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import FJAIVideoEffectUploadControlContainer from '../container/FJAIVideoEffectUploadControlContainer.jsx';
import styles from './FJAIVideoEffect.module.less';
import FJConfig from '../../../../config/FJConfig.js';
import FJVideoPreview from './FJVideoPreview.jsx';
import FJVersionConfig from '../../../../config/FJVersionConfig.js';

const FJAIVideoEffect = props => {
    const { videoEffectStyleSelectId, onChooseStyle, list } = props;

    const hoverTimer = useRef(null);
    const modalRef = useRef(null);
    const [temporaryVideo, setTemporaryVideo] = useState(null);
    const _scrollRef = useRef(null);

    const onMouseEnter = item => {
        if (hoverTimer.current) {
            clearInterval(hoverTimer.current);
            hoverTimer.current = null;
        }
        hoverTimer.current = setTimeout(() => {
            setTemporaryVideo(item);
            clearTimeout(hoverTimer.current);
        }, 200);
    };

    useEffect(() => {
        return () => {
            clearInterval(hoverTimer.current);
        };
    }, []);

    const onMouseLeave = () => {
        clearInterval(hoverTimer.current);
        hoverTimer.current = null;
        setTemporaryVideo(null);
    };

    const _scrollToVisibleArea = () => {
        const selectedIndex = list.findIndex(item => item.key === videoEffectStyleSelectId);
        const selectDom = document.getElementById(`video-effect-item-${selectedIndex}`);
        if (!selectDom) {
            return;
        }
        const selectDomRect = selectDom.getBoundingClientRect();

        const scroll = _scrollRef.current.getScroller();
        const scrollRect = scroll.getBoundingClientRect();

        // 检查选中项是否在可视区域外
        if (selectDomRect.top < scrollRect.top) {
            // 如果在可视区域上方，向上滚动
            const scrollTop = scroll.scrollTop - (scrollRect.top - selectDomRect.top);
            _scrollRef.current.scrollTop(scrollTop);
        } else if (selectDomRect.bottom > scrollRect.bottom) {
            // 如果在可视区域下方，向下滚动
            const scrollTop = scroll.scrollTop + (selectDomRect.bottom - scrollRect.bottom);
            _scrollRef.current.scrollTop(scrollTop);
        }
    };

    useEffect(() => {
        _scrollToVisibleArea();
    }, [videoEffectStyleSelectId]);

    return (
        <div className={styles.container}>
            <div className={`${styles.modal_view} ${temporaryVideo ? styles.visible : styles.hidden}`} ref={modalRef}>
                {temporaryVideo && (
                    <FJVideoPreview
                        url={
                            FJConfig.videoEffectStyleImagePath +
                            temporaryVideo.key +
                            '.mp4' +
                            '?v=' +
                            FJVersionConfig.staticPathVersion
                        }
                    />
                )}
                {temporaryVideo?.description && (
                    <div className={styles.video_desc}>{FJLocalStore._(temporaryVideo?.description)}</div>
                )}
            </div>
            <div className={styles.top}>
                <div className={styles.title}>{FJLocalStore._('choose-effect')}</div>
                <FJVerticalScroller ref={_scrollRef}>
                    <div className={styles.scroll_view}>
                        {list.map((item, index) => {
                            return (
                                <FJHoverBoardGradation
                                    onMouseEnter={() => onMouseEnter(item)}
                                    onMouseLeave={() => onMouseLeave()}
                                    active={videoEffectStyleSelectId === item.key}
                                    borderRadius={10}
                                    isShowInBorder={true}
                                    key={index}
                                    onClick={() => onChooseStyle(item.key)}
                                    id={`video-effect-item-${index}`}
                                >
                                    <FJImage
                                        imgSrc={
                                            FJConfig.videoEffectStyleImagePath +
                                            item.key +
                                            '.png' +
                                            '?v=' +
                                            FJVersionConfig.staticPathVersion
                                        }
                                        boxClassName={styles.img_content}
                                        imgClassName={styles.img}
                                    />
                                    <div className={styles.img_desc}>{FJLocalStore._(item.name)}</div>
                                </FJHoverBoardGradation>
                            );
                        })}
                    </div>
                </FJVerticalScroller>
            </div>
            <FJAIVideoEffectUploadControlContainer />
        </div>
    );
};
FJAIVideoEffect.propTypes = {
    onChooseStyle: PropTypes.func,
    videoEffectStyleSelectId: PropTypes.string,
    list: PropTypes.array,
};
export default FJAIVideoEffect;
